import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Footer from '../components/Footer';

const Pos = () => {
  return (
    <>
      <nav aria-label="breadcrumb" className="mt-5 d-flex justify-content-center">
        <ol className="breadcrumb mb-0">
          <li className="breadcrumb-item">
            <a href="/">Home</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            POS Insurance
          </li>
        </ol>
      </nav><br />

      {/* Hero Section */}
      <div className="container my-4">
        <div className="row align-items-center g-4">
          <div className="col-lg-6">
            <h1 className="display-5 fw-bold text-primary mb-3">
              Become a POS Insurance Agent
            </h1>
            <p className="lead text-muted mb-4">
              The easiest way to start your insurance career with minimal investment
            </p>
            <div className="mb-4">
              <span className="badge bg-primary bg-opacity-10 text-primary px-3 py-2 rounded-pill me-2">
                🚀 IRDAI's New Initiative
              </span>
              <span className="badge bg-success bg-opacity-10 text-success px-3 py-2 rounded-pill">
                ✅ 15-Hour Training Only
              </span>
            </div>
            <p className="mb-3" style={{ textAlign: 'justify', lineHeight: '1.8' }}>
              At <strong>Agency Bazaar</strong>, we help you become a certified <strong>POS (Point of Sale) Insurance Agent</strong> – 
              a revolutionary concept by IRDAI to democratize insurance distribution. POS agents can sell 
              simple, pre-underwritten insurance products with minimal training and licensing requirements.
            </p>
          </div>
          <div className="col-lg-6">
            <div className="bg-light rounded-4 p-4 text-center shadow-sm">
              <div className="display-1 mb-3">📱</div>
              <h4 className="text-primary">Start Your Insurance Career</h4>
              <p className="text-muted">15-hour training • Easy licensing • Quick start</p>
            </div>
          </div>
        </div>
      </div>

      {/* What is POS Insurance Agent Section */}
      <div className="container my-5">
        <div className="text-center mb-4">
          <h2 className="fw-bold text-primary">What is a <span className="text-dark">POS Insurance Agent?</span></h2>
          <div className="d-flex justify-content-center">
            <div style={{
              width: '60px',
              height: '3px',
              backgroundColor: '#0d6efd',
              borderRadius: '2px'
            }}></div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-10 mx-auto">
            <div className="p-4 shadow-sm rounded-4 bg-white">
              <p className="mb-3" style={{ fontSize: '1.05rem', lineHeight: '1.8' }}>
                A <strong>POS (Point of Sale) Insurance Agent</strong> is an <strong>IRDAI-certified professional</strong> who can sell 
                <strong> simplified insurance products</strong> with minimal training. Introduced by IRDAI in 2016, 
                this category was created to increase insurance penetration in rural and semi-urban areas. 
                Unlike traditional agents, POS agents:
              </p>
              <ul style={{ fontSize: '1rem', lineHeight: '1.8' }}>
                <li>✅ Need only <strong>15 hours of training</strong> (vs 50 hours for regular agents)</li>
                <li>✅ Can sell <strong>pre-underwritten, simple products</strong> without complex underwriting</li>
                <li>✅ Have <strong>lower examination requirements</strong> (easier pass criteria)</li>
                <li>✅ Can work as <strong>individuals or through corporate POS</strong> channels</li>
                <li>✅ Focus on <strong>rural and semi-urban markets</strong> with high growth potential</li>
              </ul>
              <div className="alert alert-primary mt-3">
                <strong>📊 Market Opportunity:</strong> India needs <strong>10 lakh+ POS agents</strong> to achieve "Insurance for All by 2047." Currently, there is a <strong>huge shortage</strong> of POS agents in rural India – creating massive opportunities!
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Benefits of Joining as POS Agent */}
      <div className="container my-5">
        <div className="text-center mb-4">
          <h2 className="fw-bold text-primary">Benefits of Joining as <span className="text-dark">POS Insurance Agent</span></h2>
          <div className="d-flex justify-content-center">
            <div style={{
              width: '60px',
              height: '3px',
              backgroundColor: '#0d6efd',
              borderRadius: '2px'
            }}></div>
          </div>
          <p className="text-muted mt-3">Why POS is the easiest entry point into insurance</p>
        </div>

        <div className="row g-4">
          <div className="col-md-6 col-lg-4">
            <div className="p-4 shadow-sm rounded-4 h-100 bg-white"
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)';
                }}
                style={{ transition: 'all 0.3s ease' }}>
              <div className="fs-1 mb-3">⏱️</div>
              <h5 className="fw-bold">Quick Training (15 Hours)</h5>
              <p className="text-muted">Complete IRDAI-approved training in just 2-3 days and start earning quickly.</p>
              <small className="text-primary">vs 50 hours for regular agents</small>
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <div className="p-4 shadow-sm rounded-4 h-100 bg-white"
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)';
                }}
                style={{ transition: 'all 0.3s ease' }}>
              <div className="fs-1 mb-3">💰</div>
              <h5 className="fw-bold">Low Entry Barrier</h5>
              <p className="text-muted">No need for 10+2 qualification. Class 10 pass can become POS agent. Perfect for rural areas!</p>
              <small className="text-primary">Minimal educational requirement</small>
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <div className="p-4 shadow-sm rounded-4 h-100 bg-white"
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)';
                }}
                style={{ transition: 'all 0.3s ease' }}>
              <div className="fs-1 mb-3">💸</div>
              <h5 className="fw-bold">Commissions on Sales</h5>
              <p className="text-muted">Earn 10-20% commission on POS insurance products. Simple products = Quick sales.</p>
              <small className="text-primary">Instant earning potential</small>
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <div className="p-4 shadow-sm rounded-4 h-100 bg-white"
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)';
                }}
                style={{ transition: 'all 0.3s ease' }}>
              <div className="fs-1 mb-3">🌾</div>
              <h5 className="fw-bold">Focus on Rural India</h5>
              <p className="text-muted">70% of India's population lives in rural areas with low insurance penetration – your market!</p>
              <small className="text-primary">Untapped opportunity</small>
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <div className="p-4 shadow-sm rounded-4 h-100 bg-white"
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)';
                }}
                style={{ transition: 'all 0.3s ease' }}>
              <div className="fs-1 mb-3">📱</div>
              <h5 className="fw-bold">Digital Platform Support</h5>
              <p className="text-muted">Use mobile apps for policy issuance, renewals, and client management – no office needed!</p>
              <small className="text-primary">Work from anywhere</small>
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <div className="p-4 shadow-sm rounded-4 h-100 bg-white"
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)';
                }}
                style={{ transition: 'all 0.3s ease' }}>
              <div className="fs-1 mb-3">👥</div>
              <h5 className="fw-bold">Social Impact</h5>
              <p className="text-muted">Help rural families get insurance protection – make a real difference in people's lives.</p>
              <small className="text-primary">Meaningful career</small>
            </div>
          </div>
        </div>
      </div>

      {/* How to Become a POS Agent */}
      <div className="container my-5">
        <div className="text-center mb-4">
          <h2 className="fw-bold text-primary">How to Become a <span className="text-dark">POS Insurance Agent</span></h2>
          <div className="d-flex justify-content-center">
            <div style={{
              width: '60px',
              height: '3px',
              backgroundColor: '#0d6efd',
              borderRadius: '2px'
            }}></div>
          </div>
          <p className="text-muted mt-3">Simple 3-step process to start your POS agent career</p>
        </div>

        <div className="row g-4">
          <div className="col-md-4">
            <div className="p-4 shadow-sm rounded-4 h-100 bg-white text-center">
              <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center mx-auto mb-3" 
                   style={{ width: '70px', height: '70px', fontSize: '28px', fontWeight: 'bold' }}>
                1
              </div>
              <h5 className="fw-bold">Complete 15-Hour Training</h5>
              <p className="text-muted">Enroll in IRDAI-approved POS training (online/offline). Learn basics of insurance, products, and regulations.</p>
              <small className="text-primary">Duration: Only 2-3 days</small>
            </div>
          </div>
          <div className="col-md-4">
            <div className="p-4 shadow-sm rounded-4 h-100 bg-white text-center">
              <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center mx-auto mb-3" 
                   style={{ width: '70px', height: '70px', fontSize: '28px', fontWeight: 'bold' }}>
                2
              </div>
              <h5 className="fw-bold">Pass Online Examination</h5>
              <p className="text-muted">Clear IRDAI's POS examination with 50% marks. Questions are simpler than regular IC-38 exam.</p>
              <small className="text-primary">50% passing marks</small>
            </div>
          </div>
          <div className="col-md-4">
            <div className="p-4 shadow-sm rounded-4 h-100 bg-white text-center">
              <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center mx-auto mb-3" 
                   style={{ width: '70px', height: '70px', fontSize: '28px', fontWeight: 'bold' }}>
                3
              </div>
              <h5 className="fw-bold">Get Certified & Start Selling</h5>
              <p className="text-muted">Receive POS agent certificate. Agency Bazaar connects you with insurers and provides digital platform.</p>
              <small className="text-primary">Start earning immediately</small>
            </div>
          </div>
        </div>
      </div>

      {/* Types of POS Products You Can Sell */}
      <div className="container my-5">
        <div className="text-center mb-4">
          <h2 className="fw-bold text-primary">POS Products <span className="text-dark">You Can Sell</span></h2>
          <div className="d-flex justify-content-center">
            <div style={{
              width: '60px',
              height: '3px',
              backgroundColor: '#0d6efd',
              borderRadius: '2px'
            }}></div>
          </div>
          <p className="text-muted mt-3">Simple, pre-underwritten products with high demand</p>
        </div>

        <div className="row g-4">
          <div className="col-md-6 col-lg-3">
            <div className="card border-0 shadow-sm h-100 text-center"
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 10px 25px rgba(0,0,0,0.12)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)';
                }}
                style={{ transition: 'all 0.3s ease' }}>
              <div className="card-body">
                <div className="fs-1 mb-2">📋</div>
                <h5 className="card-title fw-bold">POS Life Insurance</h5>
                <p className="card-text text-muted small">Simple term life cover with premiums as low as ₹2,000-5,000/year. No medical tests.</p>
                <small className="text-primary">Commission: 10-15%</small>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-3">
            <div className="card border-0 shadow-sm h-100 text-center"
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 10px 25px rgba(0,0,0,0.12)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)';
                }}
                style={{ transition: 'all 0.3s ease' }}>
              <div className="card-body">
                <div className="fs-1 mb-2">🏥</div>
                <h5 className="card-title fw-bold">POS Health Insurance</h5>
                <p className="card-text text-muted small">Basic health cover (₹2-5 Lakhs sum insured). Ideal for rural families.</p>
                <small className="text-primary">High demand product</small>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-3">
            <div className="card border-0 shadow-sm h-100 text-center"
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 10px 25px rgba(0,0,0,0.12)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)';
                }}
                style={{ transition: 'all 0.3s ease' }}>
              <div className="card-body">
                <div className="fs-1 mb-2">🚗</div>
                <h5 className="card-title fw-bold">POS Vehicle Insurance</h5>
                <p className="card-text text-muted small">Third-party car and bike insurance. Mandatory product – easy to sell!</p>
                <small className="text-primary">Legal requirement</small>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-3">
            <div className="card border-0 shadow-sm h-100 text-center"
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 10px 25px rgba(0,0,0,0.12)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)';
                }}
                style={{ transition: 'all 0.3s ease' }}>
              <div className="card-body">
                <div className="fs-1 mb-2">🏠</div>
                <h5 className="card-title fw-bold">POS Home Insurance</h5>
                <p className="card-text text-muted small">Basic home and contents insurance. Growing awareness in rural areas.</p>
                <small className="text-primary">Affordable coverage</small>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* How to Work as POS Agent - Daily Activities */}
      <div className="container my-5">
        <div className="bg-light rounded-4 p-5">
          <div className="text-center mb-4">
            <h2 className="fw-bold text-primary">How to Work as <span className="text-dark">POS Agent</span></h2>
            <div className="d-flex justify-content-center">
              <div style={{
                width: '60px',
                height: '3px',
                backgroundColor: '#0d6efd',
                borderRadius: '2px'
              }}></div>
            </div>
            <p className="text-muted mt-3">Your daily activities as a POS insurance agent</p>
          </div>
          
          <div className="row g-4">
            <div className="col-md-4">
              <div className="p-3">
                <div className="d-flex align-items-center mb-3">
                  <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: '40px', height: '40px' }}>
                    <span>🤝</span>
                  </div>
                  <h6 className="fw-bold mb-0">Client Meetings</h6>
                </div>
                <p className="text-muted small">Meet 10-15 potential customers daily in your village/town. Explain insurance benefits in simple language.</p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="p-3">
                <div className="d-flex align-items-center mb-3">
                  <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: '40px', height: '40px' }}>
                    <span>📱</span>
                  </div>
                  <h6 className="fw-bold mb-0">Policy Issuance</h6>
                </div>
                <p className="text-muted small">Use mobile app to fill basic details, collect KYC, and issue policies instantly on the spot.</p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="p-3">
                <div className="d-flex align-items-center mb-3">
                  <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: '40px', height: '40px' }}>
                    <span>🔄</span>
                  </div>
                  <h6 className="fw-bold mb-0">Renewal Follow-ups</h6>
                </div>
                <p className="text-muted small">Remind clients about policy renewals. Earn commission again on every renewal.</p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="p-3">
                <div className="d-flex align-items-center mb-3">
                  <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: '40px', height: '40px' }}>
                    <span>📢</span>
                  </div>
                  <h6 className="fw-bold mb-0">Local Marketing</h6>
                </div>
                <p className="text-muted small">Use word-of-mouth, local events, and community meetings to find new customers.</p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="p-3">
                <div className="d-flex align-items-center mb-3">
                  <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: '40px', height: '40px' }}>
                    <span>🎯</span>
                  </div>
                  <h6 className="fw-bold mb-0">Target Customers</h6>
                </div>
                <p className="text-muted small">Focus on farmers, small shop owners, daily wage workers, and families in your area.</p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="p-3">
                <div className="d-flex align-items-center mb-3">
                  <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: '40px', height: '40px' }}>
                    <span>💪</span>
                  </div>
                  <h6 className="fw-bold mb-0">Claim Assistance</h6>
                </div>
                <p className="text-muted small">Help clients with claim documentation and follow-up – build trust and referrals.</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* POS vs Regular Agent Comparison */}
      <div className="container my-5">
        <div className="text-center mb-4">
          <h2 className="fw-bold text-primary">POS Agent vs <span className="text-dark">Regular Insurance Agent</span></h2>
          <div className="d-flex justify-content-center">
            <div style={{
              width: '60px',
              height: '3px',
              backgroundColor: '#0d6efd',
              borderRadius: '2px'
            }}></div>
          </div>
        </div>

        <div className="table-responsive">
          <table className="table table-bordered table-hover">
            <thead className="bg-primary text-white">
              <tr>
                <th style={{ padding: '12px' }}>Parameter</th>
                <th style={{ padding: '12px' }}>POS Agent</th>
                <th style={{ padding: '12px' }}>Regular Agent</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><strong>Training Hours</strong></td>
                <td className="text-success fw-bold">15 Hours</td>
                <td>50 Hours</td>
              </tr>
              <tr>
                <td><strong>Educational Qualification</strong></td>
                <td className="text-success fw-bold">Class 10 Pass</td>
                <td>Class 10+2 Pass</td>
              </tr>
              <tr>
                <td><strong>Examination Difficulty</strong></td>
                <td className="text-success fw-bold">Simpler (50% pass)</td>
                <td>Complex (IC-38)</td>
              </tr>
              <tr>
                <td><strong>Products Allowed</strong></td>
                <td className="text-success fw-bold">Simple, Pre-underwritten</td>
                <td>All Insurance Products</td>
              </tr>
              <tr>
                <td><strong>Time to Start</strong></td>
                <td className="text-success fw-bold">7-10 Days</td>
                <td>1-2 Months</td>
              </tr>
              <tr>
                <td><strong>Ideal For</strong></td>
                <td className="text-success fw-bold">Rural Areas, Beginners</td>
                <td>Urban Markets, Experienced</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* Earning Potential */}
      <div className="container my-5">
        <div className="card border-0 shadow-sm bg-primary text-white">
          <div className="card-body p-5 text-center">
            <h3 className="fw-bold mb-3">💰 Your Earning Potential as POS Agent</h3>
            <div className="row mt-4">
              <div className="col-md-4">
                <div className="display-4 fw-bold">10-20%</div>
                <p>Commission on every policy</p>
              </div>
              <div className="col-md-4">
                <div className="display-4 fw-bold">₹5,000-15,000</div>
                <p>Average monthly earning (part-time)</p>
              </div>
              <div className="col-md-4">
                <div className="display-4 fw-bold">₹25,000-50,000+</div>
                <p>Full-time earning potential</p>
              </div>
            </div>
            <div className="alert alert-light mt-4 text-dark">
              <strong>💡 Pro Tip:</strong> Focus on vehicle insurance renewals – every vehicle owner needs it, and they renew every year, giving you recurring income!
            </div>
          </div>
        </div>
      </div>

      {/* Skills Required for Success */}
      <div className="container my-5">
        <div className="card border-0 shadow-sm rounded-4 bg-white">
          <div className="card-body p-4">
            <h3 className="fw-bold text-primary mb-4 text-center">Skills Required to Succeed as POS Agent</h3>
            <div className="row">
              <div className="col-md-6">
                <ul className="list-unstyled">
                  <li className="mb-3">✅ <strong>Local Language Fluency</strong> - Speak in Hindi, Tamil, Telugu, etc.</li>
                  <li className="mb-3">✅ <strong>Basic Mobile Usage</strong> - Use insurance apps for policy issuance</li>
                  <li className="mb-3">✅ <strong>Trust Building</strong> - Rural customers buy from people they trust</li>
                  <li className="mb-3">✅ <strong>Communication Skills</strong> - Explain insurance simply</li>
                </ul>
              </div>
              <div className="col-md-6">
                <ul className="list-unstyled">
                  <li className="mb-3">✅ <strong>Networking in Local Community</strong> - Connect with village heads, shopkeepers</li>
                  <li className="mb-3">✅ <strong>Patience & Perseverance</strong> - Build customer base over time</li>
                  <li className="mb-3">✅ <strong>Basic Math Skills</strong> - Calculate premiums and savings</li>
                  <li className="mb-3">✅ <strong>Empathy</strong> - Understand customer's financial situation</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Why POS is Perfect for Rural India */}
      <div className="container my-5">
        <div className="row g-4">
          <div className="col-md-6">
            <div className="bg-success bg-opacity-10 rounded-4 p-4 h-100">
              <h4 className="fw-bold text-success mb-3">🌾 India's Rural Opportunity</h4>
              <ul className="list-unstyled">
                <li className="mb-2">• <strong>65% of Indians</strong> live in rural areas</li>
                <li className="mb-2">• <strong>Only 15% have insurance</strong> coverage</li>
                <li className="mb-2">• <strong>POS agents needed:</strong> 10 Lakh+</li>
                <li className="mb-2">• <strong>Current POS agents:</strong> Only ~2 Lakhs</li>
                <li className="mb-2">• <strong>Supply gap:</strong> 8 Lakh opportunities!</li>
              </ul>
            </div>
          </div>
          <div className="col-md-6">
            <div className="bg-info bg-opacity-10 rounded-4 p-4 h-100">
              <h4 className="fw-bold text-info mb-3">🎯 Government Support</h4>
              <ul className="list-unstyled">
                <li className="mb-2">• IRDAI's <strong>POS initiative</strong> to boost insurance penetration</li>
                <li className="mb-2">• <strong>PMJJBY & PMSBY</strong> – Government insurance schemes</li>
                <li className="mb-2">• <strong>Ayushman Bharat</strong> creating awareness</li>
                <li className="mb-2">• <strong>Bima Gram</strong> – Insurance for every village</li>
                <li className="mb-2">• <strong>Digital India</strong> enabling mobile-based issuance</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="container my-5">
        <div className="bg-primary text-white rounded-4 p-5 text-center"
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.02)';
              e.currentTarget.style.transition = 'all 0.3s ease';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
            }}>
          <h2 className="fw-bold mb-3">Ready to Become a POS Insurance Agent?</h2>
          <p className="mb-4">Start your insurance career in just 7 days! Low investment, high returns, and flexible working hours.</p>
          <button
            className="btn btn-light btn-lg px-5 rounded-pill text-primary fw-bold"
            style={{ transition: 'all 0.3s ease' }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.05)';
              e.currentTarget.style.backgroundColor = '#f8f9fa';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
            }}
          >
            Enroll for POS Training Now →
          </button>
          <p className="mt-3 small opacity-75">Limited seats available for free training!</p>
        </div>
      </div>

      <Footer />
    </>
  )
}

export default Pos;


